"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKMenuItem = void 0;
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/role-supports-aria-props */
var React = __importStar(require("react"));
var common_1 = require("../../../common");
/**
 * Component representing a leaf-level item of a menu, which returns a data payload of type T on click
 */
var GKMenuItem = /** @class */ (function (_super) {
    __extends(GKMenuItem, _super);
    function GKMenuItem(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Immediately select the item, firing the onSelect callback, if registered
         */
        _this.select = function (e) {
            if (_this.props.disabled) {
                // prevent propagating the event if the element is disabled
                // this keeps the containing menu from closing when clicking
                // a disabled item
                if (e) {
                    e.stopPropagation();
                }
            }
            else if (_this.props.onSelect) {
                _this.props.onSelect(_this.props.payload);
            }
        };
        /**
         * Sets the item to be virtually focused (same as hover styling)
         */
        _this.setVirtualFocus = function (value) {
            _this.setState({ hasVirtualFocus: value });
        };
        _this.state = {
            hasVirtualFocus: false,
        };
        return _this;
    }
    GKMenuItem.prototype.render = function () {
        // If we don't destructure onSelect, the li's onClick has a type error
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var _a = this.props, active = _a.active, disabled = _a.disabled, onSelect = _a.onSelect, otherProps = __rest(_a, ["active", "disabled", "onSelect"]);
        var classes = [];
        if (this.state.hasVirtualFocus) {
            classes.push("gk-has-virtual-focus");
        }
        if (active) {
            classes.push("active");
        }
        if (disabled) {
            classes.push("gk-menu-item-disabled");
        }
        return (React.createElement("li", __assign({}, (0, common_1.mapDefaultProps)(otherProps, {
            _gkComponentName: "gk-menu-item",
            className: classes.join(" "),
            id: this.uniqueId,
        }), { "aria-selected": active, role: "menuitem", onClick: this.select }), this.props.children));
    };
    return GKMenuItem;
}(common_1.GKPureComponent));
exports.GKMenuItem = GKMenuItem;
